import React from 'react'
import { useIntl } from 'react-intl'
import { useProductListPage, ProductListLayout } from 'lib/modules/catalog'
import { useSearchTerms } from 'lib/modules/misc'

export const SearchScene = () => {
  const intl = useIntl()
  const { isLoading, searchQuery, totalCount } = useProductListPage()

  const { searchTerm, isFetching: searchTermsIsFetching } = useSearchTerms({
    search: searchQuery,
    onSuccess: ({ searchTerm, handleSearchTermRouting }) => {
      handleSearchTermRouting(searchTerm)
    }
  })

  const searchTermsLoading = Boolean(searchTermsIsFetching || searchTerm?.redirect)

  const title = isLoading
    ? intl.formatMessage({ id: 'catalog.search.title.loading' }, { searchQuery })
    : intl.formatMessage({ id: 'catalog.search.title.results' }, { searchQuery, totalCount })

  return (
    <ProductListLayout
      title={title}
      loadingState={searchTermsLoading}
      breadcrumbTitle={intl.formatMessage({ id: 'catalog.search.title.section' })}
    />
  )
}
